export type GameCatalogEntry = {
  id: string;
  title: string;
  description: string;
  href: string;
  gradient: string;
  iconKey: 'neural-runner' | 'staff-runner' | 'mystery-room';
  apiKey: string;
  leaderboardPreview: boolean;
  scoreScope: 'global' | 'daily';
};

export const GAME_CATALOG: readonly GameCatalogEntry[] = [
  {
    id: 'neural-runner',
    title: 'Neural Runner',
    description:
      'Проведи сигнал через нейросеть. Собирай данные, уклоняйся от шума, эволюционируй от перцептрона до сверхинтеллекта.',
    href: '/games/neural-runner',
    gradient: 'from-cyan-500 to-blue-600',
    iconKey: 'neural-runner',
    apiKey: 'neural-runner',
    leaderboardPreview: true,
    scoreScope: 'global',
  },
  {
    id: 'staff-runner',
    title: 'Защита образца',
    description: 'Уклоняйся от помех и защищай лабораторный образец. Классическая мини-игра на главной странице.',
    href: '/#staff-game',
    gradient: 'from-emerald-500 to-green-600',
    iconKey: 'staff-runner',
    apiKey: 'staff-runner',
    leaderboardPreview: false,
    scoreScope: 'global',
  },
  {
    id: 'mystery-room',
    title: 'Mystery Room',
    description:
      'Сетевой hidden-role контракт в лаборатории ЛИСАД: торгуйся за заказ, вычисляй преступника или сорви преступление до финального обвинения.',
    href: '/games/mystery-room',
    gradient: 'from-amber-500 via-orange-500 to-rose-600',
    iconKey: 'mystery-room',
    apiKey: 'mystery-room',
    leaderboardPreview: true,
    scoreScope: 'daily',
  },
] as const;
